import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * タグリスト
 *【ラベル内容:labelContent:string】
 *【選択候補:candidates:{label:string,value:string,selected:boolean}[]】
 *【最大表示行:maxDisplayRow:number】
 *【選択項目:selected:string[]】
 *【Select Allボタン表示フラグ:showSelectAll:boolean = true】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-tags',
  templateUrl: './tags.html',
  styles: [`
    
  `]
})
export class Tags extends BaseWidget {
  /**
   * 選択項目の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 選択項目に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * ラベル内容
   */
  @Input() labelContent:string

  /**
   * 選択候補
   */
  @Input() candidates:{label:string,value:string,selected:boolean}[]

  /**
   * 最大表示行
   */
  @Input() maxDisplayRow:number

  /**
   * 選択項目
   */
  @Input() selected:string[]

  /**
   * Select Allボタン表示フラグ
   */
  @Input() showSelectAll:boolean = true

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  /**
   * SELECT ALL/タグ押下時の表示モデル更新処理
   * @param {string[]} event
   *
   */
  updateSelected(event):void{
    this.selected = [];
    event.forEach((e) => {
      if(e.selected){
        this.selected.push(e.value);
      }
    })
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => this.selected,
      {id:this.id, type:"click", source:new Event("click")},
      `update by ${this.id}`,
    ))
    this.on("click")
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/checkbox/tags/tags.component.ts